const messagesEN = {
    // ABOUT US
    aboutUs_title: "ABOUT US",
    aboutUs_text_firstP: "Patch Notes is a small distributed game studio founded in 2017. We were gamers and have been dreaming of creating our own games long before we started our quest developing games in Patch Notes.",
    aboutUs_text_secondP: "Since 2019 we have been working on Oprør. As a company we believe in remote asynchronous communication. At least once a week timezones however do align and we socialise by playing and exploring newly launched games.",
    aboutUs_text_thirdP: "Contact:",

    // CARDS
    cards_title: "CARDS",
    cards_common: "Common",
    cards_common_text: "There are 3 different, interconnected Card Types: Units, Gear and Techs.",
    cards_rare: "Rare",
    cards_rare_text: "Grasp the power of the cards with a quick look.",
    cards_epic: "Epic",
    cards_epic_text: "Disrupt the battlefield with powerful magic-like technology",
    cards_special: "Legendary",
    cards_special_text: "Command your troops with mighty heroes.",

    // COMMON
    aboutUs: "About Us",
    download: "Newsletter",
    faq: "FAQ",
    news: "News",
    media: "Media",
    founders: "Founders",
    furnace: "Furnace",
    whitepaper: "White Paper",

    // FAQS
    faqs_title: "FAQ",
    faqs_Q1_title: "What is Oprør?",
    faqs_Q1_text: "Oprør is a card base auto-chess game. Where players set up before the battle their own decks in order to beat the opponent.",

    faqs_Q2_title: "What's the difference between Oprør and the other auto-chess out there?",
    faqs_Q2_text: "We all love auto-chess, but at Patch Notes we though there is bit to much randomness, and a lack of tactics or control. That’s what brings our card system to the table.",
    faqs_Q2_text2: " In Oprør one sets multiple Decks and goes to a Match knowing beforehand what are your strengths and weaknesses. So you can think tactically, and wear a dramatic looking commander hat.",
    faqs_Q2_text3: " Also, we want people in Oprør to be able to play the style they prefer, not being forced to choose from what is randomly available at the beginning of each match.  Hope you guys like it!",

    faqs_Q3_title: "In what platform will Oprør be available?",
    faqs_Q3_text: "Our game will be at the beginning on PC and mobile.",

    faqs_Q4_title: "Will there be cross-platform play?",
    faqs_Q4_text: "Yes, from the moment we released the Android and iOS versions, cross-platform to other mobiles or pc player will be a reality.",

    faqs_Q5_title: "How much will Oprør cost?",
    faqs_Q5_text: "Oprør is a forever free to play game. Though you may purchase in-game cosmetics.",

    faqs_Q6_title: "Will I get any advantages if I pay money in the game?",
    faqs_Q6_text: "No. Well maybe that we will be able to afford food for dinner, yay!",

    faqs_Q7_title: "There will be loot boxes in Oprør?",
    faqs_Q7_text: "Yes, the card packs will deliver randomly 5 card to the players, but there are other other ways to get a specific desired card.",

    faqs_Q8_title: "What types of cards are there?",
    faqs_Q8_text: "There are three, units, Gear and Tech cards.",

    faqs_Q9_title: "Can I only buy skins with real money?",
    faqs_Q9_text: "Not at all! You can also unlock any relevant and cool skin with in game currency, which is obtainable as rewards for battles and missions.",

    faqs_Q10_title: "Will there be events and special offers?",
    faqs_Q10_text: "Absolutely, some skins and aesthetics will be available only for special occasions.",

    faqs_Q11_title: "Can I play with friends?",
    faqs_Q11_text: "Well, yes. You just need to have friends.",

    faqs_Q12_title: "In what languages will Oprør be released?",
    faqs_Q12_text: "At the beginning in English and maybe will put other languages like Spanish or German.",

    faqs_Q13_title: "Is Oprør only multiplayer or there is also a single player mode?",
    faqs_Q13_text: "At the beginning we will release the multiplayer mode, but we are secretly working on single player mode… Or maybe not so secretly.",

    // FOOTER
    impressum: "Impressum",
    datenschutz: "Datenschutz",

    // GAME CONTENT
    gameContent_chessboard: "BATTLEBOARD.",
    gameContent_chessboard_text: "Plan your strategy, think ahead of your opponents to overthrow your rival!",
    gameContent_tank: "TANKS",
    gameContent_tank_text: "Upgrade your units, level them up or use any possible mean to turn your cute little car into a death-evoking machine.",
    gameContent_drones: "D.R.O.N.E.S.",
    gameContent_drones_text: "War is always entertaining... but so is tourism! Fly around between your own matches or when watching a friend die horribly! Enjoy the view with this fancy looking free-flying drones!",
    gameContent_maps: "MAPS",
    gameContent_maps_text: "To win a battle one must know the terrain... or just make it more pretty. Either works. Edit your battlefield and map to accommodate to your tastes.",

    // HEROES
    heroes_title: "HEROES",
    heroes_Milosh_heroName: "MILOSH",
    heroes_Milosh_heroSubtitle: "The Space Zombie",
    heroes_Milosh_text: "After a bizarre accident involving Orgoth and insane amounts of vodka, Milosh woke up in a flagship’s sickbay feeling weird.  He was dead, but not quite. Proclaimed dead for the records, but still able to talk, move… and command. He just needs to stay inside his “unlife” support suit. His new condition gave him a special affinity and connection with the Void, granting him powers of control over tainted units by the Anathema.",

    heroes_Zeph_heroName: "ZEPH",
    heroes_Zeph_heroSubtitle: "The Merc",
    heroes_Zeph_text: "Trying to remember a life before the first “Event” is meaningless, so is trying to run away from war. Zeph learned this in the hardest of ways after his home planet was wiped out by the Anathema. Joining the SPQRO as a soldier of fortune was a no brainer for him after that, reaching the level of “Second Unit Commander” in no time. Though his allegiance lies with his paycheck, his uttermost desire is to fight the Anathema until the last man… even if it means literally that.    ",

    heroes_Yul_heroName: "YUL",
    heroes_Yul_heroSubtitle: "The Sheriff",
    heroes_Yul_text: "There've been cases of 'Tamarak individuals' where these sentient machines break the link with the Motherhive and thrive into different sectors of society. This is the case of Yul, the Tamarak Sheriff of Terra Sector. For decades he became the icon of law and order, and after the last Anomaly Event he took the career of Commanding Officer. Despite his condition of 'Outcast', tamarak units will accept to follow his commands in battle.",

    heroes_Sekhmet_heroName: "SEKHMET",
    heroes_Sekhmet_heroSubtitle: "The Assassin",
    heroes_Sekhmet_text: "The karathi are one of the most enigmatic races that came through the Rifts, highly belligerent, yet with strict codes of conduct and honor. Some of their clans were known for being secretive and treacherous. From one of these clans Sekhmet emerged. She quickly became one of the best assassins of the SPQRO, and led many Dark Operations. She applied for the position of Legionare Commander, and in no time she excelled in combat as a careful, relentless strategist.",

    heroes_Til_heroName: "TIL",
    heroes_Til_heroSubtitle: "The Tank",
    heroes_Til_text: "Strong, bad tempered, short-fused and with an irrational hate for the Anathema, Til became a commander with only one idea: to crush every single last one of them, or die trying. His hate for the Void is only measurable against his fear for vegetable based food, which for him is considered the worst torture in this universe. He personally oversees the works on his units to make them stronger in order to sustain more damage when he sends them charging towards the front line.",

    // MEDIA
    media_art: "ART",
    media_sreenshots: "SCREENSHOTS",

    // NEWS
    news_titleBg: "NEWS!",
    news_title: "RECENT NEWS",

    // OPROAR
    opror_title: "The battle is close!",
    opror_text: "Plan, adapt, overcome. Oprør is a tactical card based auto-battler, where luck alone won't save you. Choose a hero, prepare a deck, send your troops to the board, and see heroes sacrifice for glory, peace or vengance.",

    // POP UP
    popup_title: "Subscribe to our newsletter!",
    popup_text_p1: "I have read and accept the",
    popup_text_blue: "Terms and Conditions",
    popup_text_p3: "of PatchNotes",
    popup_subscribe: "Subscribe",

    // TOPBAR
    topbar_downloadNow: "Newsletter",

    terms_and_conditions_title: "General Terms of Use",

    terms_1_title: "1. General information",
    terms_1_p1: "In compliance with Law 34/2002 of 11 July on Information Society Services and Electronic Commerce (LSSI-CE), it is hereby reported that the website www.opror.com (hereinafter, the “Website”) is owned by Patch Notes S.L., with registered office at Calle Núñez de Balboa 94, Planta 1, Puerta C, 28006, Madrid, Tax ID B72950645, and registered in the Commercial Registry of Madrid.",
    terms_1_p2: "You can contact us via email: hello@patchnotes.com.",

    terms_2_title: "2. Purpose",
    terms_2_p1: "These General Terms govern access, browsing and use of the Website, as well as the relationship between users and Patch Notes S.L. (hereinafter, the “Company”). Accessing and using the Website implies full and unreserved acceptance of these General Terms.",

    terms_3_title: "3. Access and use of the website",
    terms_3_p1: "Access to the Website is free of charge, except for any cost arising from the connection through the Internet service provider.",
    terms_3_p2: "The user undertakes to use the contents, information and services appropriately, in accordance with the law, morality, public order and these General Terms. The following is expressly prohibited:",
    terms_3_l1: "Using the Website for unlawful purposes or against good faith.",
    terms_3_l2: "Reproducing, distributing or modifying the contents without the Company’s express authorization.",
    terms_3_l3: "Attempting to access restricted areas or IT systems of the Company or third parties.",

    terms_4_title: "4. Intellectual and industrial property",
    terms_4_p1: "All contents of the Website, including but not limited to: design, texts, graphics, logos, icons, buttons, software, trade names, trademarks and other distinctive signs, are the property of Patch Notes S.L. or their lawful owners and are protected by national and international intellectual and industrial property laws.",
    terms_4_p2: "The user is granted only a personal, non-exclusive right of use strictly limited to browsing the Website.",

    terms_5_title: "5. Content related to the video game Oprør",
    terms_5_p1: "All materials, images, videos, character names, settings, music and other elements of the video game Oprør are the exclusive property of Patch Notes S.L. Their reproduction, distribution, public communication or transformation is prohibited without the Company’s prior written authorization.",

    terms_6_title: "6. Links",
    terms_6_p1: "The Website may include links to third-party websites. Patch Notes S.L. is not responsible for the contents, policies or practices of such sites. The inclusion of these links does not imply any relationship, approval or endorsement by the Company.",

    terms_7_title: "7. Liability",
    terms_7_p1: "Patch Notes S.L. does not guarantee the continuous availability of the Website nor the absence of errors in the contents, although it will make all reasonable efforts to avoid and correct them as soon as possible. The Company is not liable for any damages that may arise from improper use of the Website by users.",

    terms_8_title: "8. Personal data protection",
    terms_8_p1: "The processing of personal data that may be collected through the Website shall be governed by the provisions of the Privacy Policy, which the user must expressly accept.",

    terms_9_title: "9. Modifications",
    terms_9_p1: "Patch Notes S.L. reserves the right to modify, at any time and without prior notice, the presentation and configuration of the Website, as well as these General Terms.",

    terms_10_title: "10. Applicable law and jurisdiction",
    terms_10_p1: "These General Terms are governed by Spanish law. For the resolution of any dispute or conflict arising from access to or use of the Website, the parties submit to the Courts and Tribunals of Madrid, unless another jurisdiction is established by law.",


    // PRIVACY POLICY
    privacy_title: "Privacy Policy",

    privacy_1_title: "1. General information",
    privacy_1_p1: "This Privacy Policy explains how Patch Notes S.L. processes personal data when you access and browse the website www.opror.com (the “Website”) and when you interact with us. We process data in accordance with the EU General Data Protection Regulation (GDPR) and the Spanish LOPDGDD (Organic Law 3/2018).",

    privacy_2_title: "2. Data controller",
    privacy_2_p1: "Controller: Patch Notes S.L., Calle Núñez de Balboa 94, Planta 1, Puerta C, 28006, Madrid, Tax ID B72950645. Contact email: hello@patchnotes.com.",

    privacy_3_title: "3. Personal data we collect",
    privacy_3_p1: "We may process the following categories of personal data:",
    privacy_3_l1: "Contact data: name and email address.",
    privacy_3_l2: "Usage and browsing data: IP address, device identifiers, pages visited, interactions on the Website, approximate location, and error logs.",
    privacy_3_l3: "Communications data: information contained in messages you send us via forms or email.",
    privacy_3_l4: "Newsletter subscription data: email address and communication preferences.",
    privacy_3_p2: "We do not request special categories of data. If you provide such information unintentionally, we will securely delete it unless strictly required by law.",

    privacy_4_title: "4. Purposes and legal bases",
    privacy_4_l1: "Operate the Website and provide requested features (legal basis: legitimate interest and/or performance of pre-contractual measures).",
    privacy_4_l2: "Respond to inquiries and support requests (legal basis: legitimate interest and/or pre-contractual measures).",
    privacy_4_l3: "Manage your subscription and send our newsletter and marketing communications (legal basis: your consent, which you may withdraw at any time).",
    privacy_4_l4: "Website security, fraud prevention, and aggregated analytics (legal basis: legitimate interest).",
    privacy_4_l5: "Comply with applicable legal obligations (legal basis: legal obligation).",

    privacy_5_title: "5. Data retention",
    privacy_5_p1: "We retain your data for as long as necessary to fulfill the purposes described and, thereafter, for the periods required by law. For the newsletter, we will keep your data until you withdraw your consent or unsubscribe. After these periods, data will be deleted or anonymized securely.",

    privacy_6_title: "6. Recipients and processors",
    privacy_6_p1: "We may share data with service providers (e.g., hosting, analytics, email delivery) acting as data processors under contracts that ensure confidentiality and security.",
    privacy_6_p2: "We do not sell personal data. We may disclose data where required by law or to comply with requests from competent authorities.",

    privacy_7_title: "7. International transfers",
    privacy_7_p1: "If we use providers located outside the European Economic Area, we will ensure an adequate level of protection through European Commission adequacy decisions or, where not available, by executing Standard Contractual Clauses or other safeguards recognized by the GDPR.",

    privacy_8_title: "8. Your rights",
    privacy_8_p1: "You can exercise your data protection rights by emailing hello@patchnotes.com, verifying your identity and specifying the right you wish to exercise.",
    privacy_8_l1: "Access: know what data we process.",
    privacy_8_l2: "Rectification: correct inaccurate or incomplete data.",
    privacy_8_l3: "Erasure: request deletion of your data where appropriate.",
    privacy_8_l4: "Object: object to certain processing based on legitimate interest.",
    privacy_8_l5: "Restriction: request restriction of processing in certain cases.",
    privacy_8_l6: "Portability: receive your data in a structured format and transmit it to another controller.",
    privacy_8_p2: "You also have the right to lodge a complaint with the Spanish Data Protection Agency (AEPD) at www.aepd.es if you believe your rights have been infringed.",

    privacy_9_title: "9. Security",
    privacy_9_p1: "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, destruction, or alteration. However, no system is completely secure and we cannot guarantee absolute security.",

    privacy_10_title: "10. Cookies",
    privacy_10_p1: "We use cookies and similar technologies for Website operation and analytics. For more information about how we use cookies, please refer to our Cookies Policy.",

    privacy_11_title: "11. Changes to this Privacy Policy",
    privacy_11_p1: "We may update this Privacy Policy to reflect legal or processing changes. We will publish the current version on the Website and indicate the date of the last update.",


    // COOKIES POLICY
    cookies_title: "Cookies Policy",

    cookies_1_title: "1. What are cookies?",
    cookies_1_p1: "Cookies are data storage and retrieval devices placed on your device when you visit certain websites, as provided by Spanish Law 34/2002 (LSSI-CE). Cookies help remember your preferences, perform measurements, and improve browsing experience.",

    cookies_2_title: "2. Controller",
    cookies_2_p1: "Cookie-related controller: Patch Notes S.L., Calle Núñez de Balboa 94, Planta 1, Puerta C, 28006, Madrid, Tax ID B72950645. Contact: hello@patchnotes.com.",

    cookies_3_title: "3. Types of cookies we may use",
    cookies_3_p1: "On this Website we may use cookies classified by entity, duration, and purpose:",
    cookies_3_l1: "By entity: first-party (managed by us) and third-party (managed by providers).",
    cookies_3_l2: "By duration: session (deleted when the browser closes) and persistent (remain for a defined period).",
    cookies_3_l3: "By purpose: technical/necessary; preferences/customization; analytics/measurement; advertising; and behavioral advertising.",
    cookies_3_l4: "Technical or necessary: enable basic Website functions. Do not require consent.",
    cookies_3_l5: "Preferences, analytics and advertising: remember options, produce statistics, and show ads. Require your prior consent.",

    cookies_4_title: "4. Cookies subject to consent",
    cookies_4_p1: "We will not set non-technical cookies without your prior consent obtained via the banner or settings panel. You can withdraw your consent at any time without retroactive effect.",

    cookies_5_title: "5. Cookies used on the Website",
    cookies_5_p1: "We currently use the following categories of cookies. Detailed information (provider, purpose, duration) is available in the cookies settings panel:",
    cookies_5_l1: "Technical or necessary: traffic management, load balancing, security, user session, language preference.",
    cookies_5_l2: "Preferences or customization: remember your options (e.g., language or region).",
    cookies_5_l3: "Analytics or measurement: help understand how users interact with the Website (e.g., pages visited, time on site).",
    cookies_5_l4: "Advertising and behavioral advertising: manage ad space and create profiles based on browsing habits to show personalized ads.",

    cookies_6_title: "6. How to configure or disable cookies",
    cookies_6_p1: "You can accept, reject, or configure cookies at any time via the banner or the settings panel available on the Website. You can also configure your browser to block or delete cookies.",
    cookies_6_p2: "Learn how to manage cookies in common browsers:",
    cookies_6_l1: "Chrome: support.google.com/chrome/answer/95647",
    cookies_6_l2: "Firefox: support.mozilla.org/kb/cookies-information-websites-store-on-your-computer",
    cookies_6_l3: "Safari: support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471",
    cookies_6_l4: "Edge: support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09",

    cookies_7_title: "7. Third-party cookies",
    cookies_7_p1: "Where third-party cookies are used, such third parties are responsible for them and their policies. You can check further details in their privacy and cookies notices. We will keep the list of third parties up to date in the settings panel.",

    cookies_8_title: "8. International transfers",
    cookies_8_p1: "If providers are located outside the European Economic Area, we will ensure an adequate level of protection via European Commission adequacy decisions or, where not available, by entering into Standard Contractual Clauses or other appropriate safeguards under the GDPR.",

    cookies_9_title: "9. Retention",
    cookies_9_p1: "Session cookies are deleted when you close the browser. Persistent cookies are kept for the period indicated in the settings panel or until you delete them. Data derived from cookies may be kept in aggregate form for statistical purposes for additional periods.",

    cookies_10_title: "10. Updates to this Cookies Policy",
    cookies_10_p1: "We may update this Policy to reflect legal or technical changes. We will publish the current version on the Website and indicate the date of the last update where applicable.",

    cookies_11_title: "11. Contact",
    cookies_11_p1: "For any questions regarding the use of cookies, please email hello@patchnotes.com.",
}

export default messagesEN;
